import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";
import SearchPanel from "@widgets/SearchPanel";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PUR_BAS_REG_003_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    //#endregion
    const today = new Date();
    const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
    //#region Components useState
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const searchRef = useRef<any>(null);
    const [popupParent, setPopupParent] = useState<any>(null);
    const [initFlag, setInitFlag] = useState<boolean>(false);
    const [doubleData, setDoubleData] = useState<any[]>();
    //#endregion

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let lsChk: any = "2";
        const checkedRows =
          doubleData && doubleData.length > 0
            ? doubleData
            : gridRefs.current["grid1"].current?.getCheckedRows() || [];
        for (const row of checkedRows) {
          if (row?.um === "" || row?.um === null || row?.um === undefined) {
            lsChk = "1";
            break;
          } else {
            lsChk = "2";
          }
        }
        if (lsChk === "1") {
          const confirm = await showDialog(
            "confirm",
            "단가 정보가 누락되었습니다. 진행하시겠습니까?"
          );
          if (!confirm) return { flag: false };
        }
        return { flag: true };
      },
      getSelectedRow: () => {
        if (doubleData && doubleData.length > 0) {
          return [doubleData];
        }
        return [gridRefs.current["grid1"].current?.getCheckedRows() || []];
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PUR_BAS_REG_003_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
          });
          setInitFlag(true);
        } catch (error) {}
      };
      fetchform();
    }, []);

    // useEffect(() => {
    //   if (initFlag) onSearch();
    // }, [initFlag]);

    //#region Button Event
    const onSearch = async () => {
      try {
        const param = {
          id: "sn_pur_bas_reg_003_pop_01",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_cust: formData.cd_cust,
            cd_cust_rcv: searchRef.current.getFormdata().cd_cust_rcv,
          },
        };

        gridRefs.current["grid1"].current.resetUpdate();
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
        });

        if (!data[0] || data[0].length === 0) {
          await showDialog("alter", "신규품목이 없습니다.");
        }
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    //#region OnSave
    // const onSave = async () => {
    //   let virtualTable: any = [];
    //   let newData: any;
    //   const renderedNodes = gridRef1.current.api.getRenderedNodes();
    //   if (renderedNodes.length === 0) return;
    //   for (const node of renderedNodes) {
    //     newData = {
    //       cd_firm: userInfo.cd_firm,
    //       cd_module: "PUR",
    //       tp_um: selectedData.tp_um,
    //       cd_exch: "000",
    //       cd_item: node.data?.cd_item,
    //       nm_item: node.data?.nm_item,
    //       um: node.data?.um,
    //       um_supply: node.data?.um_supply,
    //       dt_start: todayform,
    //       dt_end: "21001231",
    //       cd_cust: node.data?.cd_cust_rcv,
    //       nm_cust: node.data?.nm_cust,
    //       dc_item_spec: node.data?.dc_item_spec,
    //       dc_item_unit: node.data?.dc_item_unit,
    //       dc_rmk: node.data?.dc_rmk,
    //       cd_user_reg: userInfo.cd_user,
    //     };
    //     virtualTable.push(newData);
    //   }
    //   const SaveData = {
    //     mas_umcust: { insert: virtualTable },
    //   };
    //   await fnSave("SN_PUR_BAS_REG_003_SAVE_01", SaveData);
    //   //gridRef1.current?.resetUpdate();
    // };

    //#endregion

    //#region Event Method
    const onCellValueChanged = (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;

      if (colId === "um") {
        const um_supply = +(rowData.um * 1.1);
        rowNode.setDataValue("um_supply", um_supply, "noEvent");
      }
      if (colId === "um_supply") {
        const um = +((rowData.um_supply * 10) / 11);
        rowNode.setDataValue("um", um, "noEvent");
      }
    };

    const onCellDoubleClicked = (e: any) => {
      console.log(e);
      let returnData: any[] =
        gridRefs.current["grid1"].current?.getCheckedRows();
      const exists = returnData.some((data) => data.cd_item === e.data.cd_item);
      if (!exists) returnData.push(e.data);
      setDoubleData(returnData);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCellValueChanged: onCellValueChanged,
            onCellDoubleClicked: onCellDoubleClicked,
          },
        },
      }),
      [columns, dataSources]
    );
    //#endregion

    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "multiple",
              ischeckboxSelection: true,
              popupParent: popupParent,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_PUR_BAS_REG_003_POP_01;
